export default __webpack_public_path__ + "9aee875ed209c90543a71a57bd4cc1c3.png";